/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';

import './create.scss';
import '../fake.scss';

const BASE_WIDTH = 140;
const TEXT_HEIGHT = 15;

const FAKE_STYLES = {
	icon: {
		width: `${BASE_WIDTH}px`,
		height: `${BASE_WIDTH}px`,
		margin: '20px'
	},
	text: {
		width: `${BASE_WIDTH+20}px`,
		height: `${TEXT_HEIGHT}px`
	},
	wideText: {
		width: `${BASE_WIDTH+80}px`,
		height: `${TEXT_HEIGHT}px`
	},
	button: {
		width: `${BASE_WIDTH}px`,
		height: '40px',
		margin: '20px'
	}
};

class FakeCreateExplorationLayout extends Component {

	render() {


		return (
			<div className="create-exploration">
				<div className="create-exploration__container ">
					{this.props.fill ?
						<div className='fake' style={FAKE_STYLES.icon} />
						: null
					}
					<div className='fake' style={FAKE_STYLES.text}/>
					<div className='fake' style={FAKE_STYLES.wideText}/>
					<div className='fake' style={FAKE_STYLES.text}/>
					<div className='fake' style={FAKE_STYLES.button}/>
				</div>
			</div>
		);
	}

}

FakeCreateExplorationLayout.propTypes = {
	fill: PropTypes.bool.isRequired
};

export default FakeCreateExplorationLayout;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/create/FakeCreateExplorationLayout.js